import { JsonFormPropertyV2 } from '../types'
import { DefaultValues } from 'react-hook-form'
import { FormValues } from '../types'
import { parse, isValid, format } from 'date-fns'

// Create initial values with proper typing
export const createDefaultValues = (properties: JsonFormPropertyV2[]) => {
  const defaults: Record<string, unknown> = {}

  properties.forEach((field) => {
    let defaultValue: unknown = field.default

    // Handle specific types
    if (field.type === 'array' && !defaultValue) {
      defaultValue = []
    } else if (
      field.type === 'boolean' &&
      (defaultValue === undefined || defaultValue === null || defaultValue === '')
    ) {
      defaultValue = false
    } else if (
      (field.type === 'string' || field.type === 'number' || field.type === 'integer') &&
      (defaultValue === undefined || defaultValue === null)
    ) {
      defaultValue = ''
    } else if (field.format === 'date' && typeof defaultValue === 'string' && defaultValue !== '') {
      const inputDateString = defaultValue as string
      const candidateFormats = ['yyyy-MM-dd', 'dd-MM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy']

      let parsedDate: Date | null = null
      for (const candidateFormat of candidateFormats) {
        const attempt = parse(inputDateString, candidateFormat, new Date())
        if (isValid(attempt)) {
          parsedDate = attempt
          break
        }
      }

      if (!parsedDate) {
        const normalized = inputDateString.replace(/\//g, '-')
        for (const candidateFormat of ['yyyy-MM-dd', 'dd-MM-yyyy']) {
          const attempt = parse(normalized, candidateFormat, new Date())
          if (isValid(attempt)) {
            parsedDate = attempt
            break
          }
        }
      }

      if (parsedDate) {
        // defaultValue = parsedDate
        defaultValue = format(parsedDate, 'yyyy-MM-dd')
      } else {
        const constructed = new Date(inputDateString)
        if (!Number.isNaN(constructed.getTime())) {
          // defaultValue = constructed
          defaultValue = format(constructed, 'yyyy-MM-dd')
        }
      }
    } else if (
      (field.format === 'datetime' || field.format === 'date-time') &&
      typeof defaultValue === 'string' &&
      defaultValue !== ''
    ) {
      const inputDateTimeString = defaultValue as string

      const candidateDateTimeFormats = ["yyyy-MM-dd'T'HH:mm:ss"]

      let parsedDateTime: Date | null = null
      for (const candidateFormat of candidateDateTimeFormats) {
        const attempt = parse(inputDateTimeString, candidateFormat, new Date())
        if (isValid(attempt)) {
          parsedDateTime = attempt
          break
        }
      }

      if (parsedDateTime) {
        // Normalize to canonical format for datetime fields
        const y = parsedDateTime.getFullYear()
        const m = String(parsedDateTime.getMonth() + 1).padStart(2, '0')
        const d = String(parsedDateTime.getDate()).padStart(2, '0')
        const hh = String(parsedDateTime.getHours()).padStart(2, '0')
        const mm = String(parsedDateTime.getMinutes()).padStart(2, '0')
        const ss = String(parsedDateTime.getSeconds()).padStart(2, '0')
        defaultValue = `${y}-${m}-${d}T${hh}:${mm}:${ss}`
      } else {
        const constructed = new Date(inputDateTimeString)
        if (!Number.isNaN(constructed.getTime())) {
          const y = constructed.getFullYear()
          const m = String(constructed.getMonth() + 1).padStart(2, '0')
          const d = String(constructed.getDate()).padStart(2, '0')
          const hh = String(constructed.getHours()).padStart(2, '0')
          const mm = String(constructed.getMinutes()).padStart(2, '0')
          const ss = String(constructed.getSeconds()).padStart(2, '0')
          defaultValue = `${y}-${m}-${d}T${hh}:${mm}:${ss}`
        }
      }
    } else if (field.type === 'cascading' && !defaultValue) {
      // Initialize empty cascading field structure
      defaultValue = {
        level1: '',
        level2: '',
        level3: field.isMultiSelect?.level3 ? [] : '',
      }
    }

    defaults[field.id] = defaultValue
  })

  return defaults as DefaultValues<FormValues>
}
